import Vue from 'vue'
import App from './App.vue'
import fastclick from "fastclick";
import router from "./router";
import "vant/lib/index.css";
import appConfig from "./config/appConfig";
import Vconsole from 'vconsole';
import requestUtil from "./config/requestUtil";
import mixin from "./lib/mixin.js";
import {InfiniteScroll, Lazyload, Loadmore, Spinner} from "mint-ui";
import "mint-ui/lib/style.css";
// import { Table, TableColumn } from 'element-ui'
// Vue.use(Table);
// Vue.use(TableColumn);

import {
  Cell, CellGroup,
    Button,
    Checkbox,
    CheckboxGroup,
    Icon,
    NavBar,
    NumberKeyboard,
    PasswordInput,
    Popup,
    PullRefresh,
    Swipe,
    SwipeItem,
    Toast,
} from "vant";

Vue.mixin(mixin);
Vue.config.productionTip = false
Vue.prototype.$axios = requestUtil;
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(PasswordInput).use(NumberKeyboard);
Vue.use(Swipe).use(SwipeItem);
Vue.use(PullRefresh);
Vue.use(Popup);
Vue.use(NavBar);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Loadmore);
Vue.use(Lazyload);
Vue.use(InfiniteScroll);
Vue.use(Lazyload);
Vue.use(Spinner);
Vue.use(Cell);
Vue.use(CellGroup);

fastclick.attach(document.body);
Vue.prototype.$appConfig = appConfig;

router.beforeEach((to, from, next) => {
  //假设当前是首页，一会判断
  // 先判断当前是否有上一页，预防刷新页面
  let result = "";
  if (from.name) {
    result = {
      // 当前页
      currentPage: to.name,
      currentPageQuery: to.query,
      currentPageParams: to.params,
      // 上一页
      lastPage: from.name,
      lastPageQuery: from.query,
      lastPageParams: from.params
    };
    sessionStorage.setItem("pageLink", JSON.stringify(result));
  } else {
    // 刷新页面或者首页
    if (
      to.name == "home" || 
      to.name == "shopDetial" || 
      to.name == "physicalStore"
    ) {
      // 首页/商家详情（线下/线上）
      result = {
        // 当前页
        currentPage: to.name,
        currentPageQuery: to.query,
        currentPageParams: to.params,
        // 上一页
        lastPage: from.name,
        lastPageQuery: from.query,
        lastPageParams: from.params
      };
      sessionStorage.setItem("pageLink", JSON.stringify(result));
    } else {
      //刷新页面,不做任何操作
    }
  }
  let token = localStorage.getItem("accessToken");
  if (to.meta.requireAuth) {
    if (!token) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
          time: new Date().getTime()
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
  
  sessionStorage.setItem("router_name", to.name);
});
if (appConfig.openLog) {
  new Vconsole();
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
